<template>
  <div class="flex justify-end container" style="margin-top: 32px">
    <OnboardingBtn
      text="上一步"
      type="plain"
      :width="106"
      style="margin-right: 16px"
      @click="prev"
    />
    <OnboardingBtn :text="rightText || '下一步'" :width="106" :disabled="disabled" @click="next" />
  </div>
</template>
<script>
import OnboardingBtn from './OnboardingBtn.vue';
export default {
  name: 'ProgressBtnGroup',
  components: {
    OnboardingBtn,
  },
  props: {
    disabled: Boolean,
    rightText: String,
  },
  methods: {
    prev() {
      this.$emit('prev');
    },
    next() {
      this.$emit('next');
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  width: 622px;
  margin-left: 64px;
}
</style>
